const allowedBrowsers = {
  mobile: {
    safari: '>=3.2',
  },
  safari: '>=6.1',
  chrome: '>=21',
  firefox: '>=28',
  opera: '>=12.1',
  'internet explorer': '>10',
  'Microsoft Edge': '>0',
}

export default allowedBrowsers
